<section class="container">
    <div *ngIf="distributorInfo" class="distributorInformation text-right">
        <div *ngIf="distributorInfo.name" class="bold header-font color-black distributor-name ">
            {{distributorInfo | displayNameFormat}}
        </div>
        <div *ngIf="distributorInfo.displayName && distributorInfo.memberTypeId === memberTypeEnum.DISTRIBUTOR" class="bold">
            <span>{{distributorInfo.displayName | titlecase}}</span>
          </div>
        <div class="font14">
            <a *ngIf="distributorInfo?.distributorId"><i class="fa fa-copy" [copyToClipboard]="distributorInfo.distributorId"></i></a>
            <span class="color-black" *ngIf="distributorInfo.distributorId">{{distributorInfo.distributorId |distributorIdFormat}}</span>
            <span *ngIf="distributorInfo.level"> | {{distributorInfo.level}}</span>
        </div>
    </div>

    <div class="w-100">        
        <!-- Activity Log table -->
        <div class="text-left" >
          <strong>   {{'member-activity-log.Activity Log' |translate |translateKey}}   </strong>
        </div>
        <div class="table-responsive">          
                <table class="table table-striped custab">
                    <thead>
                        <tr>  
                             <th (click)="sortMemberActivityLogs('UserName')" class="pointer">{{'member-activity-log.User' |translate | translateKey}}&nbsp;
                                 <i class="fa" [ngClass]="{'fa-sort': sortBy != 'UserName', 'fa-sort-asc': (sortBy == 'UserName' && !isDesc), 'fa-sort-desc': (sortBy == 'UserName' && isDesc) }"
                                            aria-hidden="true"> </i>
                             </th>
                             <th (click)="sortMemberActivityLogs('createdDate')" class="pointer">{{'member-activity-log.Created Date' |translate | translateKey}}&nbsp;
                                 <i class="fa" [ngClass]="{'fa-sort': sortBy != 'createdDate', 'fa-sort-asc': (sortBy == 'createdDate' && !isDesc), 'fa-sort-desc': (sortBy == 'createdDate' && isDesc) }"
                                            aria-hidden="true"> </i>
                             </th>
                            <th>{{'member-activity-log.Timestamp' |translate | translateKey}}</th>                       
                            <th>{{'member-activity-log.Portal' |translate | translateKey}}</th>
                            <th>{{'member-activity-log.Log Description' |translate | translateKey}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let activity of memberActivityLogInfo | paginate: {  id: 'memberActivityLogs-pagination'+'_'+fboid, itemsPerPage: pageSize, currentPage: pageNumber, totalItems: pageCount }">
                            <td>{{activity.user}} </td>
                            <td *ngIf="activity.createdDate!='null'">{{activity.monthDateFormat}}</td>
                            <td *ngIf="activity.createdDate=='null'"></td>
                            <td *ngIf="activity.createdDate!='null'">{{activity.hoursDateFormat}}</td>
                            <td *ngIf="activity.createdDate=='null'"></td>
                            <td>{{activity.portalName}}</td>
                            <td>{{activity.message}}</td>
                        </tr>
                    </tbody>
                     <tbody *ngIf="memberActivityLogInfo?.length===0">
                        <tr>
                            <td colspan="6" class="text-center">{{'member-activity-log.Logs not available.' |translate |translateKey}}</td>
                        </tr>
                    </tbody> 
                </table>
            </div>
            <div class="alert-white rounded grid-count">
                    {{pageCount}} {{'member-activity-log.record(s) found' |translate}}
                    <pagination-controls [id]="paginationInstance.id+'_'+fboid" (pageChange)="pageChange($event)" class="pull-right"></pagination-controls>
            </div>
    </div>

</section>


// WEBPACK FOOTER //
// ./src/app/customerservice/templates/template1/views/member-activity-logs.component.html